import { includes, join, toLower } from "lodash"

const RESOURCE_TYPES = [
  "PORTFOLIO",
  "WATCHLIST",
  "SWAP",
  "CLASSIFICATION",
  "RESEARCH_TOPIC",
  "FORECAST",
  "CONTENT_SET",
  "TEMPLATE",
] as const

// [TODO:TS] This belongs in a resource file that doesn't exist yet
interface Resource {
  name: string
  type: ResourceType
}

export type ResourceType = typeof RESOURCE_TYPES[number]

export function isPermissionedResource(resourceType: ResourceType) {
  return includes(RESOURCE_TYPES, resourceType)
}

export function getResourceLabel({ name, type }: Resource) {
  return join([name, toLower(type === "SWAP" ? "basket" : type)], " - ")
}
